import { bindable, bindingMode} from 'aurelia-framework';

export class CheckBox {
	@bindable({ defaultBindingMode: bindingMode.oneTime }) label: string = '';
	@bindable({ defaultBindingMode: bindingMode.twoWay }) isChecked: boolean = false;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) isEnabled: boolean = true;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) click: any = function () { return false; };
	@bindable({ defaultBindingMode: bindingMode.oneTime }) isFormControl: string = 'true';

	constructor() { }
}